module.exports = __webpack_public_path__ + "img/266.6aadfe9e.jpg";